var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmployee = function SvgEmployee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.167a.5.5 0 0 1 .5.5v1.166h5.833a2.5 2.5 0 0 1 2.5 2.5v9.333a2.5 2.5 0 0 1-2.5 2.5H3.667a2.5 2.5 0 0 1-2.5-2.5V5.333a2.5 2.5 0 0 1 2.5-2.5H9.5V1.666a.5.5 0 0 1 .5-.5ZM9.5 5V3.833H3.667a1.5 1.5 0 0 0-1.5 1.5v9.334a1.5 1.5 0 0 0 1.5 1.5h12.666a1.5 1.5 0 0 0 1.5-1.5V5.333a1.5 1.5 0 0 0-1.5-1.5H10.5V5a.5.5 0 0 1-1 0Zm-4.417 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm4.5 2.166a.5.5 0 0 1 .5-.5h2.5a.5.5 0 1 1 0 1h-2.5a.5.5 0 0 1-.5-.5Zm.5 1.167a.5.5 0 1 0 0 1h2.5a.5.5 0 1 0 0-1h-2.5Z",
    fill: "#818C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.167a.5.5 0 0 1 .5.5v1.166h5.833a2.5 2.5 0 0 1 2.5 2.5v9.333a2.5 2.5 0 0 1-2.5 2.5H3.667a2.5 2.5 0 0 1-2.5-2.5V5.333a2.5 2.5 0 0 1 2.5-2.5H9.5V1.666a.5.5 0 0 1 .5-.5ZM9.5 5V3.833H3.667a1.5 1.5 0 0 0-1.5 1.5v9.334a1.5 1.5 0 0 0 1.5 1.5h12.666a1.5 1.5 0 0 0 1.5-1.5V5.333a1.5 1.5 0 0 0-1.5-1.5H10.5V5a.5.5 0 0 1-1 0Zm-4.417 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm4.5 2.166a.5.5 0 0 1 .5-.5h2.5a.5.5 0 1 1 0 1h-2.5a.5.5 0 0 1-.5-.5Zm.5 1.167a.5.5 0 1 0 0 1h2.5a.5.5 0 1 0 0-1h-2.5Z",
    fill: "#747F88"
  })));
};

export default SvgEmployee;